
import {store} from '../../store/index.js';

export default {
    install(vue, opts) {

        vue.$company = {
        	lookup: function(vatNo, options) {
        		console.log(vatNo);
        	},
        }

    }
}
